import { render, staticRenderFns } from "./RCard.vue?vue&type=template&id=a1172550&scoped=true"
import script from "./RCard.vue?vue&type=script&lang=js"
export * from "./RCard.vue?vue&type=script&lang=js"
import style0 from "./RCard.vue?vue&type=style&index=0&id=a1172550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1172550",
  null
  
)

export default component.exports